import { Injectable } from '@angular/core';
import { ContentFactory } from '../squidex/factories/content.factory';
import { DynamicContentSchemaFacade } from './dynamic-content-schema/dynamic-content.facade';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from './dynamic-schema.factory';

@Injectable({ providedIn: 'root' })
export class DynamicContentSchemaFactory {

    constructor(
        private readonly contentFactory: ContentFactory,
        private readonly dynamicSchemaFacto: DynamicSchemaFactory,
        private readonly translateService: TranslateService) { }

    getDynamicContentSchemaFacade(schemaName: string): DynamicContentSchemaFacade {
        return new DynamicContentSchemaFacade(schemaName,
            this.contentFactory,
            this.dynamicSchemaFacto,
            this.translateService);
    }
}
